import RouletteStyleContextProvider from "../components/roulette/settings/context/RouletteStyleContextProvider";
import RouletteDesignSettings from "../components/roulette/settings/RouletteDesignSettings";

const RoulettePageV2 = () => {

    return (
        <RouletteStyleContextProvider>
            <RouletteDesignSettings />
        </RouletteStyleContextProvider>
    )
}

export default RoulettePageV2;